import React from 'react';
import Grupo from 'components/Grupo';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {useStyles} from './style';

const MenuVertical=(props)=>{
    const classes = useStyles(props);

    return (
        <div>
            <div className={classes.title}>Menú</div>
            {(props.menu!==null) ?
                Object.keys(props.menu).map((key,index) =>{
                    return (
                        <div key={index}
                            onClick={()=>{
                                props.SET_MENU_ITEM_GROUP(index);
                            }}
                        >
                            <Grupo group={props.menu[key]}></Grupo>
                        </div>
                    )
                }):''
            }
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(MenuVertical);
